import app from "./app";
import auth from "./auth";
import common from "./common";

const reducers = { auth, app, common };

export default reducers;
